import React from 'react';
import {
  Row,
  Col,
} from 'antd';
import PropTypes from 'prop-types';

import OnTraccrNumberInput from '../../common/inputs/OnTraccrNumberInput';
import DisplayText from '../../common/text/DisplayText';
import CompanyEditRow from '../CompanyEditRow';

export default function ManualOvertime({
  settings,
  onSettingsChange,
}) {
  const {
    manualOTModifier = 1.5,
  } = settings;

  return (
    <CompanyEditRow
      title="Overtime Pay Rate"
      divider={false}
    >
      <Row gutter={4} align="middle" style={{ marginTop: 10 }}>
        <Col>
          <DisplayText title="wage x" style={{ marginBottom: 0 }} />
        </Col>
        <Col>
          <OnTraccrNumberInput
            style={{ width: 65 }}
            formatter={(value) => (Number.isNaN(Number(value)) ? 0 : value)}
            onChange={(value) => onSettingsChange({ manualOTModifier: value })}
            onPressEnter={(e) => onSettingsChange({ manualOTModifier: e.target.value })}
            defaultValue={manualOTModifier}
            min={0}
            max={99}
            step={0.25}
          />
        </Col>
      </Row>
    </CompanyEditRow>
  );
}

ManualOvertime.propTypes = {
  settings: PropTypes.shape({
    manualOTModifier: PropTypes.number,
  }),
  onSettingsChange: PropTypes.func,
};

ManualOvertime.defaultProps = {
  settings: {
    manualOTModifier: 1.5,
  },
  onSettingsChange: () => {},
};
